import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LabelI18nService } from 'src/app/core/_services/label-i18n.service';
import { WorkInspectionModel } from 'src/app/core/_models/workInspection';

@Component({
  selector: 'app-work-inspection-project',
  templateUrl: './work-inspection-project.component.html',
  styleUrls: ['./work-inspection-project.component.scss']
})
export class WorkInspectionProjectComponent {
  @Input() currentItem!: WorkInspectionModel;
  @Input() wsAppPath!: string;

  constructor(
    private translate: TranslateService,
    private labelI18n: LabelI18nService
  ) {}

  get projectTypesDisplay(): string {
    if (!this.currentItem?.projectType?.length) {
      return this.translate.instant('common_not_specified');
    }
    return this.currentItem.projectType.map((pt) => this.labelI18n.projectTypeName(pt.code, pt.displayName)).join(', ');
  }
}
